"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _drei = require("@react-three/drei");
var _reactErrorBoundary = require("react-error-boundary");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StorageWaterHeaterContent = props => {
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const {
    nodes,
    materials
  } = (0, _drei.useGLTF)("".concat(source).concat(_constants.webGLModalsSource, "/200_water_assets/204_storage_water_heater.glb"));
  const shadows = {
    castShadow: true,
    receiveShadow: false
  };
  return /*#__PURE__*/_react.default.createElement("group", _extends({}, props, {
    dispose: null
  }), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['01_top_bottom'].geometry,
    material: materials['Component.WhiteDefault'],
    position: [0, 5.03, 0],
    scale: [6.25, 11.75, 6.25]
  }, shadows), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#E4E7EC",
    roughness: "0.1"
  })), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['02_glas'].geometry,
    material: materials['Component.WhiteDefault'],
    position: [0, 6.87, 0],
    scale: [6.84, 12.85, 6.84]
  }, shadows), /*#__PURE__*/_react.default.createElement("meshPhongMaterial", {
    color: "#E4E7EC",
    transparent: "true",
    opacity: "1"
  })), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['03_ring_top'].geometry,
    material: materials['Component.EmissionRot'],
    position: [0, 16.31, 0],
    scale: 1.43
  }, shadows), /*#__PURE__*/_react.default.createElement("meshPhongMaterial", {
    color: "#FF0000",
    emissive: "#FF0000",
    emissiveIntensity: 1,
    attach: "material"
  })), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['04_ring_bottom'].geometry,
    material: materials['Component.EmissionBlau'],
    position: [0, -4.92, 0],
    scale: 1.43
  }, shadows), /*#__PURE__*/_react.default.createElement("meshPhongMaterial", {
    color: "#81D1F7",
    emissive: "#81D1F7",
    emissiveIntensity: 1,
    attach: "material"
  })));
};
const StorageWaterHeater = (0, _reactErrorBoundary.withErrorBoundary)(StorageWaterHeaterContent, {
  FallbackComponent: () => null,
  onError: (err, info) => console.error(err, info)
});
var _default = exports.default = StorageWaterHeater;